import { Typography } from "@circle-react-uikit/Typography";

interface TextContentProps {
  content: string;
}

export const TextContent = ({ content }: TextContentProps) => (
  <Typography.BodySm color="text-default">{content}</Typography.BodySm>
);
